/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:15/03/2021
 @Time:08:39
 **/
import LangueService from "../../../i18n/service/LangueService";

export default class ProduitEtiquette{


    /**
     * @type {string}
     * @private
     */
    #_id;

    /**
     * les nom des étiquettes
     * @type {Object<String,String>}
     * @private
     */
    #_nom={};


    get id() {
        return this.#_id;
    }

    set id(value) {
        this.#_id = value;
    }

    /**
     * ajoute la traduction d'une etiquette pour une langue prédéfinit
     * @param locale
     * @param nom
     * @return {string|null}
     */
    addNomTraduction(locale,nom)
    {
        return this.#_nom[locale]=nom;
    }

    /**
     * supprime une traduction pour une ligne
     * @param {string=} locale si non définit on retourne le nom traduit dans la langue active
     */
    removeNomTraduction(){

        (this.#_nom[locale]!==undefined)?delete this.#_nom[locale]:null;
    }


    getNom(locale=LangueService.getInstance().activeLangue.locale){
        return (this.#_nom[locale]!==undefined)?this.#_nom[locale]:null;
    }

    /**
     * Convert une etiquette d'une format json vers une instance de produit etiquette
     * @param {{}}etiquetteJson
     * @return {ProduitEtiquette}
     */
    static createFromJson(etiquetteJson)
    {
        let produitEtiquette=new ProduitEtiquette();
        produitEtiquette.id=etiquetteJson.id;
        for(let locale in etiquetteJson.traductions)
        {
            let traduction=etiquetteJson.traductions[locale];
            produitEtiquette.addNomTraduction(locale,traduction.nom);
        }
        Begro.logInfo("Produit étiquette ayant id "+produitEtiquette.id+" a été crée");
        return produitEtiquette;
    }

}